<ion-item>
  <ion-select [label]="item.name | translate" [value]="item.selected" (ionChange)="item.change($event)">
    <ion-select-option *ngFor="let option of item.options" [value]="option.value">
      {{ option.text | translate }}
    </ion-select-option>
  </ion-select>
</ion-item>
